import React from 'react';

import { X } from 'lucide-react';

import DocumentViewer from '../DocumentViewer';

interface DocumentViewerPanelProps {
	isVisible: boolean;
	onClose: () => void;
	document: {
		id: string;
		name: string;
		type: string;
		date: string;
		size: string;
		status: string;
		processingMonth: string;
		pdfUrl?: string;
		results?: any;
	};
}

const DocumentViewerPanel: React.FC<DocumentViewerPanelProps> = ({
	isVisible,
	onClose,
	document,
}) => {
	if (!isVisible) return null;

	return (
		<div className="fixed inset-y-0 right-0 w-2/3 bg-white shadow-2xl border-l border-gray-200 z-50 transform transition-transform duration-300 ease-in-out">
			{/* Document Panel Header */}
			<div className="flex items-center justify-between p-4 bg-gray-50 border-b border-gray-200">
				<h3 className="text-lg font-semibold text-gray-900">Document Viewer</h3>
				<button
					onClick={onClose}
					className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-200 rounded-lg transition-colors"
				>
					<X className="w-5 h-5" />
				</button>
			</div>

			{/* Document Viewer Content */}
			<div className="h-full">
				<DocumentViewer document={document} />
			</div>
		</div>
	);
};

export default DocumentViewerPanel;
